module.exports = __webpack_public_path__ + "static/media/search_web_1.75dca242.png";